import { UnistylesRegistry } from 'react-native-unistyles'

import { breakpoints, theme } from '@ui-kit/theme'

type AppBreakpoints = typeof breakpoints
type AppThemes = {
  default: typeof theme
}

declare module 'react-native-unistyles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface UnistylesThemes extends AppThemes {}
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface UnistylesBreakpoints extends AppBreakpoints {}
}

UnistylesRegistry.addThemes({
  default: theme,
})
  .addBreakpoints(breakpoints)
  .addConfig({
    adaptiveThemes: true,
  })
